import React, { useContext, useEffect, useState, useCallback } from "react";
import { Box, TextField, Tab, CircularProgress } from "@mui/material";
import {
  East as EastIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { pathJoinUrl } from "@smfa/utils/src";
import soaplogo from "../assets/img/soap-logo.webp";

import { AppContext } from "../context";
import {
  getAffiliateBanner,
  getAffiliates,
  addEditAffiliatesBanner,
  addEditAffiliates,
  deleteAffiliates,
} from "../actions/affiliates.actions";

import DeleteModal from "../ui-components/DeleteModal";
import FileUploadArea from "./common/FileUploadArea";

/**
 *
 * @returns {JSX.Element}
 * @component
 */
const Affiliates = () => {
  const { storage } = useContext(AppContext);
  const [value, setValue] = useState("1");
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  var addAboutBanner_default = {
    banner_section_id: 0,
    banner_image: "",
    banner_image_name: "",
    banner_image_error: false,
    banner_image_mob: "",
    banner_image_mob_name: "",
    banner_image_mob_error: false,
    banner_title: "",
    banner_title_maxlenth: 50,
    banner_title_error: false,
  };

  const [addAboutBanner, setAboutBanner] = useState(addAboutBanner_default);
  const [affiliatesList, setAffiliatesList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchType, setSearchType] = useState("section_qualification");
  const [pageLoader, setPageLoader] = useState(false);

  var addAffiliates_default = {
    affiliates_id: 0,
    affiliates_image: "",
    affiliates_image_name: "",
    affiliates_image_error: false,
    affiliates_title: "",
    affiliates_title_maxlenth: 50,
    affiliates_title_error: false,
    link: "",
    link_maxlenth: 100,
    link_error: false,
  };

  // eslint-disable-next-line no-unused-vars
  const [addAffiliates, setAffiliates] = useState(addAffiliates_default);

  const handleChangeedit = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setValue(newValue);
  };
  const handleChange = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setDeskLogoImage("");
    setAffiliates(addAffiliates_default);
    setValue(newValue);
  };

  const [desklogoimage, setDeskLogoImage] = useState(soaplogo);
  const onImageLogoChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAffiliates };
    if (event.target.files[0]) {
      setDeskLogoImage(URL.createObjectURL(event.target.files[0]));
      custInfo.affiliates_image = event.target.files[0];
      custInfo.affiliates_image_name = event.target.files[0].name;
      custInfo.affiliates_image_error = false;
      setAffiliates(custInfo);
    }
  };

  const [deskimage, setDeskImage] = useState("");

  const onImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files[0]) {
      setDeskImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image = event.target.files[0];
      custInfo.banner_image_name = event.target.files[0].name;
      custInfo.banner_image_error = false;
      setAboutBanner(custInfo);
    }
  };

  const [mobimage, setMobImage] = useState("");
  const onMobImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files && event.target.files[0]) {
      setMobImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image_mob = event.target.files[0];
      custInfo.banner_image_mob_name = event.target.files[0].name;
      custInfo.banner_image_mob_error = false;
      setAboutBanner(custInfo);
    }
  };

  const clearBannerUpload = (field, clearPreview) => {
    clearPreview("");
    setAboutBanner((previous) => ({
      ...previous,
      [field]: "",
      [`${field}_name`]: "",
    }));
  };

  const clearAffiliateUpload = () => {
    setDeskLogoImage("");
    setAffiliates((previous) => ({
      ...previous,
      affiliates_image: "",
      affiliates_image_name: "",
    }));
  };

  // Enhanced fetch function with better error handling
  const fetchData = useCallback(async () => {
    try {
      setFirstLoading(true);

      // Call our new action creators
      const [bannerResponse, affiliatesResponse] = await Promise.all([
        getAffiliateBanner(),
        getAffiliates({
          pageNo: 1,
          perPage: 50,
          searchText: "",
          searchType: "section_qualification",
        }),
      ]);

      // Handle banner response
      if (bannerResponse?.data?.status) {
        setAboutBanner(bannerResponse.data.data);
      }

      // Handle affiliates response
      if (affiliatesResponse?.data?.status) {
        setAffiliatesList(affiliatesResponse.data.data || []);
      }
    } catch (error) {
      log.error("Error fetching affiliate data:", error);
      setErrorMsg(
        "Failed to load affiliate data. Please try refreshing the page.",
      );
    } finally {
      setFirstLoading(false);
    }
  }, []);

  // Use the enhanced fetch function in your useEffect
  useEffect(() => {
    fetchData();

    // Cleanup function
    return () => {
      // Any cleanup needed
    };
  }, [fetchData]);

  const addAboutBannerInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.name === "banner_title") {
      if (event.target.value.length <= addAboutBanner.banner_title_maxlenth) {
        custInfo.banner_title = event.target.value;
        custInfo.banner_title_error = false;
      }
    }

    setAboutBanner(custInfo);
  };

  const submitLocation = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addAboutBanner };

    if (addAboutBanner.banner_title === "") {
      document.getElementById("banner_title").focus();
      custInfo.banner_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setAboutBanner(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append("banner_section_id", addAboutBanner.banner_section_id);
    formData.append("banner_image_mob", addAboutBanner.banner_image_mob);
    formData.append("banner_image", addAboutBanner.banner_image);
    formData.append("banner_title", addAboutBanner.banner_title);

    if (addAboutBanner.banner_section_id === 0) {
      addEditAffiliatesBanner(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Join  Addedd Successfully!");
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setAboutBanner(addAboutBanner_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setAboutBanner(addAboutBanner_default);
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    } else {
      addEditAffiliatesBanner(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Banner Updated Successfully!");
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong,please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    }
  };

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);

    getAffiliates({
      pageNo: 1,
      perPage: e.target.value,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setAffiliatesList(res.data.data);
      } else {
        setAffiliatesList(res.data.data);
      }
    });
  };

  const changePage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setPageLoader(true);
    setPageNo(page);

    getAffiliates({
      pageNo: page,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setAffiliatesList(res.data.data);
      } else {
        setAffiliatesList(res.data.data);
      }
      setPageLoader(false);
    });
  };

  const addAffiliatesInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAffiliates };
    if (event.target.name === "affiliates_title") {
      if (
        event.target.value.length <= addAffiliates.affiliates_title_maxlenth
      ) {
        custInfo.affiliates_title = event.target.value;
        custInfo.affiliates_title_error = false;
      }
    }
    if (event.target.name === "link") {
      if (event.target.value.length <= addAffiliates.link_maxlenth) {
        custInfo.link = event.target.value;
        custInfo.link_error = false;
      }
    }

    setAffiliates(custInfo);
  };

  const submitLocationnew = () => {
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addAffiliates };

    if (addAffiliates.affiliates_title === "") {
      document.getElementById("affiliates_title").focus();
      custInfo.affiliates_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setAffiliates(custInfo);

      setLoader(false);
      return false;
    }
    if (addAffiliates.link === "") {
      document.getElementById("link").focus();
      custInfo.link_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setAffiliates(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append("affiliates_id", addAffiliates.affiliates_id);
    formData.append("affiliates_image", addAffiliates.affiliates_image);
    formData.append("affiliates_title", addAffiliates.affiliates_title);
    formData.append("link", addAffiliates.link);
    formData.append(
      "section_qualification",
      addAffiliates.section_qualification,
    );

    if (addAffiliates.affiliates_id === 0) {
      addEditAffiliates(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setAffiliates(addAffiliates_default);
            setSuccessMsg("Affiliates  Addedd Successfully!");
            setDeskLogoImage("");
            getAffiliates({
              pageNo: pageNo,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setAffiliatesList(res.data.data);
              } else {
                setAffiliatesList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "3");
            }, 1000);
          } else {
            setAffiliates(addAffiliates_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setAffiliates(addAffiliates_default);
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    } else {
      addEditAffiliates(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setAffiliates(addAffiliates_default);
            setDeskLogoImage("");
            setSuccessMsg("Affiliates Updated Successfully!");

            getAffiliates({
              pageNo: 1,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setAffiliatesList(res.data.data);
              } else {
                setAffiliatesList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "3");
            }, 1000);
          } else {
            setErrorMsg("Something went wrong,please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    }
  };

  const editLocation = (e, val) => {
    var locInfo = { ...addAffiliates };
    locInfo.affiliates_id = val.affiliates_id;
    locInfo.link = val.link;
    locInfo.affiliates_title = val.affiliates_title;
    locInfo.section_qualification = val.section_qualification;
    locInfo.affiliates_image_name = val.affiliates_image;
    if (val.affiliates_image !== null) {
      setDeskLogoImage(
        pathJoinUrl(storage[0].imageEndUrl, val.affiliates_image),
      );
    }
    setAffiliates(locInfo);

    setSuccessMsg("");
    setErrorMsg("");
    const startEvent = new Event("start");

    handleChangeedit(startEvent, "2");
  };

  const checkfilsiw = (newValue) => {
    setErrorMsg("");
    setSearchText("");

    if (newValue === "affiliates_title") {
      setSearchType("affiliates_title");
      document.getElementById("affiliates_title").style.display = "block";
      document.getElementById("section_qualification").style.display = "none";
      // document.getElementById("location").style.display = 'none';
    }
  };

  const checksortall = (newValue, sort) => {
    let element;
    setErrorMsg("");
    if (newValue === "affiliates_title") {
      if (sort === "desc") {
        element = document.getElementById("affiliates_titleasc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        // override
        element = document.getElementById("affiliates_titledesc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
      if (sort === "asc") {
        element = document.getElementById("affiliates_titledesc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        // override
        element = document.getElementById("affiliates_titleasc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
    }

    setFirstLoading(true);
    getAffiliates({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
      sort: sort,
      sortvalue: newValue,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setAffiliatesList(res.data.data);
      } else {
        setAffiliatesList([]);
      }
      setFirstLoading(false);
    });
  };

  const doSearch = (e) => {
    if (e.target.name === "affiliates_title") {
      setSearchText(e.target.value);
    }
  };

  const gosubmit = (e) => {
    setErrorMsg("");

    if (searchType === "affiliates_title") {
      if (searchText === "") {
        return false;
      }
    }

    setFirstLoading(true);
    getAffiliates({
      pageNo: 1,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setAffiliatesList(res.data.data);
      } else {
        setAffiliatesList([]);
      }
      setFirstLoading(false);
    });
  };

  const clearfilter = () => {
    setErrorMsg("");
    setSearchText("");
    setDeskLogoImage("");
    setSearchType("affiliates_title");
    setFirstLoading(true);

    document.getElementById("affiliates_title").style.display = "block";
    //  document.getElementById("location").style.display='none';

    setAffiliatesList([]);
    getAffiliates({
      pageNo: 1,
      perPage: perPage,
      searchText: "",
      searchType: "affiliates_id",
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setAffiliatesList(res.data.data);
      } else {
        setAffiliatesList([]);
      }
      setFirstLoading(false);
    });
  };

  const resetdoc = () => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setAffiliates(addAffiliates_default);
  };

  const [deleteItem, setDeleteItem] = useState(null);

  const handleDelete = (item) => {
    setDeleteItem(item);
  };

  const handleDeleteSuccess = () => {
    setDeleteItem(null);
    setFirstLoading(true);
    getAffiliates({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      setAffiliatesList(res.data.data);
      setFirstLoading(false);
    });
  };

  return (
    <>
      <div className="content">
        <div className="body-inner-sec">
          <div className="container-fluid">
            <div className="row">
              <div className="banner-inner-bdy-sec tab-sec-smfa">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Add Banner" value="1" />

                        <Tab
                          label={` ${addAffiliates.affiliates_id !== 0 ? "Update" : "Add"} Partners`}
                          value="2"
                        />
                        <Tab label="Manage Partners" value="3" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div className="banner-inner-bdy-sec tab-sec-smfa bene-margin-bot">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="banner_title"
                                    label="Title"
                                    variant="standard"
                                    onChange={addAboutBannerInfo}
                                    name="banner_title"
                                    value={addAboutBanner.banner_title}
                                    error={addAboutBanner.banner_title_error}
                                    helperText={` ${addAboutBanner.banner_title_error === true ? "Please enter Title!" : ""}`}
                                  />

                                  <div className="charcter-sec">
                                    {addAboutBanner.banner_title_maxlenth -
                                      addAboutBanner.banner_title.length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addAboutBanner.banner_title_maxlenth -
                                            addAboutBanner.banner_title.length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-5 banner-uplod-secs">
                            <FileUploadArea
                              title="Add Banner Image For Desktop"
                              description={
                                <>
                                  Best image Resolution: 1920px X 836px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={deskimage}
                              fileName={addAboutBanner.banner_image_name}
                              onChange={onImageChange}
                              deleteRequest={{
                                resource: "affiliate-banner",
                                id: addAboutBanner.banner_section_id,
                                field: "banner_image",
                              }}
                              onRemove={() =>
                                clearBannerUpload("banner_image", setDeskImage)
                              }
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                          <div className="col-md-5 banner-uplod-secs">
                            <FileUploadArea
                              title="Add Banner Image For Mobile"
                              description={
                                <>
                                  Best image Resolution: 400px X 350px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={mobimage}
                              fileName={addAboutBanner.banner_image_mob_name}
                              onChange={onMobImageChange}
                              deleteRequest={{
                                resource: "affiliate-banner",
                                id: addAboutBanner.banner_section_id,
                                field: "banner_image_mob",
                              }}
                              onRemove={() =>
                                clearBannerUpload(
                                  "banner_image_mob",
                                  setMobImage,
                                )
                              }
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec"
                              style={{ marginTop: "30px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocation();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Banner Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong,please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div className="banner-inner-bdy-sec tab-sec-smfa bene-margin-bot">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="affiliates_title"
                                    label="Partner Name"
                                    variant="standard"
                                    onChange={addAffiliatesInfo}
                                    name="affiliates_title"
                                    value={addAffiliates.affiliates_title}
                                    error={addAffiliates.affiliates_title_error}
                                    helperText={` ${addAffiliates.affiliates_title_error === true ? "Please enter Partner Name!" : ""}`}
                                  />
                                  <div className="charcter-sec">
                                    {addAffiliates.affiliates_title_maxlenth -
                                      addAffiliates.affiliates_title.length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec max-scht-secc">
                                          Max Characters:&nbsp;
                                          {addAffiliates.affiliates_title_maxlenth -
                                            addAffiliates.affiliates_title
                                              .length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="link"
                                    label="Link"
                                    variant="standard"
                                    onChange={addAffiliatesInfo}
                                    name="link"
                                    value={addAffiliates.link}
                                    error={addAffiliates.link_error}
                                    helperText={` ${addAffiliates.link_error === true ? "Please enter Link!" : ""}`}
                                  />
                                  <div className="charcter-sec">
                                    {addAffiliates.link_maxlenth -
                                      addAffiliates.link.length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec max-scht-secc">
                                          Max Characters:&nbsp;
                                          {addAffiliates.link_maxlenth -
                                            addAffiliates.link.length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-5 banner-uplod-secs">
                            <FileUploadArea
                              title="Add Partners Logo"
                              description={
                                <>
                                  Best image Resolution: 98px X 52px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={desklogoimage}
                              fileName={addAffiliates.affiliates_image_name}
                              onChange={onImageLogoChange}
                              deleteRequest={{
                                resource: "affiliate",
                                id: addAffiliates.affiliates_id,
                                field: "affiliates_image",
                              }}
                              onRemove={clearAffiliateUpload}
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div className="button-sec">
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocationnew();
                                  e.preventDefault();
                                }}
                              >
                                {addAffiliates.affiliates_id !== 0
                                  ? "Update"
                                  : "Save"}
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <button
                                type="button"
                                className="btn btn-login btn-reset"
                                onClick={(e) => {
                                  resetdoc();
                                  e.preventDefault();
                                }}
                              >
                                Reset
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Slider Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong,please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="3">
                      <div className="table-sec-main">
                        <div className="top-table-sec">
                          <div className="row">
                            <div className="col-md-2">
                              <div className="sota-table-inner">
                                <p>Show Entries</p>
                                <select
                                  className="selectsec"
                                  onChange={perPageChange}
                                  value={perPage}
                                >
                                  <option value={10}>10</option>
                                  <option value={25}>25</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="total-count">
                                {affiliatesList.length > 0 ? (
                                  <p>
                                    Total Partners{" "}
                                    <span className="number-count">
                                      {totalCount}
                                    </span>
                                  </p>
                                ) : null}
                              </div>
                              <div className="tab-manage-sec clear-sec">
                                <button
                                  className=""
                                  onClick={(e) => clearfilter()}
                                >
                                  Clear Filter
                                </button>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="filter-sec">
                                <div
                                  className="form-secs filter-form-sec"
                                  id="affiliates_title"
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="standard-basic"
                                      label="Partner Name"
                                      variant="standard"
                                      value={searchText}
                                      name="affiliates_title"
                                      onChange={doSearch}
                                    />
                                    <EastIcon onClick={(e) => gosubmit()} />
                                  </Box>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-table-sec">
                            <div className="row">
                              <div className="col-md-12">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr className="tab-head-sec">
                                      <th className="admin-sl  serial-sec">
                                        Sl No
                                      </th>
                                      <th
                                        className="label-sec"
                                        onClick={(e) =>
                                          checkfilsiw("affiliates_title")
                                        }
                                      >
                                        Partner Name
                                        <span
                                          className="top-sort "
                                          id="affiliates_titledesc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-up"
                                            onClick={(e) =>
                                              checksortall(
                                                "affiliates_title",
                                                "desc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                        <span
                                          className="bottom-sort  sortopacity"
                                          id="affiliates_titleasc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-down"
                                            onClick={(e) =>
                                              checksortall(
                                                "affiliates_title",
                                                "asc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </th>

                                      <th className="para-sec">Link</th>
                                      <th className="desk-img-sec">
                                        Partner Logo
                                      </th>
                                      <th className="action-sec">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {firstLoading ? (
                                      <tr className="td-sec">
                                        <td colSpan={5}>
                                          <div
                                            className="spinner-border"
                                            role="status"
                                            style={{
                                              width: "1rem",
                                              height: "1rem",
                                              marginLeft: "6px",
                                            }}
                                          ></div>
                                        </td>
                                      </tr>
                                    ) : (
                                      <>
                                        {affiliatesList.length > 0 ? (
                                          affiliatesList.map((userd, index) => (
                                            <tr
                                              key={index}
                                              className="tab-data-sec"
                                            >
                                              <td className="tab-border-left">
                                                {pageNo * perPage -
                                                  perPage +
                                                  1 +
                                                  index}
                                              </td>
                                              <td>{userd.affiliates_title}</td>
                                              <td>{userd.link}</td>
                                              <td className="mob-img-data partners-logo-news">
                                                {userd.affiliates_image !==
                                                  "" &&
                                                  userd.affiliates_image !=
                                                    null && (
                                                    <img
                                                      src={pathJoinUrl(
                                                        storage[0].imageEndUrl,
                                                        userd.affiliates_image,
                                                      )}
                                                      alt="[]"
                                                    />
                                                  )}
                                              </td>

                                              <td className="edit-sec">
                                                <EditIcon
                                                  onClick={(e) =>
                                                    editLocation(e, userd)
                                                  }
                                                />
                                                <DeleteIcon
                                                  onClick={() =>
                                                    handleDelete(userd)
                                                  }
                                                  className="del-admn-sec"
                                                />
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={5}>No Data Found</td>
                                          </tr>
                                        )}
                                      </>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* pagination start */}
                          {totalPage > 1 ? (
                            <>
                              {pageLoader ? (
                                <div
                                  className="spinner-border"
                                  role="status"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    marginLeft: "6px",
                                    float: "right",
                                    position: "absolute",
                                    bottom: "73px",
                                    right: "35px",
                                  }}
                                ></div>
                              ) : (
                                ""
                              )}

                              <div
                                className="pagination-sec"
                                style={{
                                  boxShadow: "#e29a1217 0px 7px 16px 0px",
                                  width: "auto",
                                  float: "right",
                                  border: "1px solid #0cb8b6",
                                  marginTop: "2px",
                                  marginRight: "20px",
                                  height: "40px",
                                }}
                              >
                                <div
                                  style={{
                                    float: "left",
                                    padding: "0px",
                                    color: "rgb(11, 92, 171)",
                                    fontSize: "14px",
                                    width: "100%",
                                    position: "relative",
                                    display: "inline-flex",
                                  }}
                                >
                                  <div className="pagin-sec">
                                    <i
                                      className="fa-solid fa-angle-left"
                                      onClick={(e) => changePage(pageNo - 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginLeft: "9px",
                                        marginRight: "10px",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "1px",
                                        marginRight: "1px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      Go to{" "}
                                    </span>
                                    <input
                                      className="number-secs"
                                      type="number"
                                      value={pageNo}
                                      onChange={(e) => {
                                        !isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) > 0
                                          ? changePage(parseInt(e.target.value))
                                          : changePage(1);
                                      }}
                                      style={{
                                        color: "rgb(0, 23, 55)",
                                        margin: "9px 6px 0px 4px",
                                        fontSize: "14px",
                                        width: "34px",
                                        height: "22px",
                                        float: "left",
                                        textAlign: "center",
                                        border: "1px solid rgb(114, 114, 114)",
                                        borderRadius: "3px",
                                        outline: "none",
                                      }}
                                    />
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "2px",
                                        marginRight: "2px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      of {totalPage}{" "}
                                    </span>
                                    <i
                                      className="fa-solid fa-angle-right"
                                      onClick={(e) => changePage(pageNo + 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginRight: "6px",
                                        marginLeft: "5px",
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        open={deleteItem !== null}
        title={"Delete Partner"}
        message={"Are you sure you want to delete this Partner?"}
        handleClose={() => setDeleteItem(null)}
        handleSuccess={handleDeleteSuccess}
        deleteAction={deleteAffiliates}
        data={deleteItem ? { affiliates_id: deleteItem.affiliates_id } : null}
      />
    </>
  );
};

export default Affiliates;
